// config-v2-schema.ts
//
// V2 spec §7 "Config ↔ CLI": `~/.avatar/autopilot-config.json` is shared by
// every workspace on the machine and its v1 schema is `.strict()` at every
// level — CLI 3.34.x rejects the WHOLE file on one unknown key. Keys added by
// V2 therefore live in a sibling file, `autopilot-config.v2.json`, with its
// own strict schema; a missing file means every default below.
import { z } from "zod";

export const AutopilotConfigV2Schema = z
  .object({
    /** §4.1 trần quyết định máy tự áp mỗi mission (consumer: phase 03). Read from the run's snapshot. Trần trên 20 (Luke chốt, review phase 02 L5). */
    max_auto_decisions_per_mission: z.number().int().min(0).max(20).default(3),
    /** §6.1 xuất telemetry autopilot (consumer: phase 09; pinned at init there). */
    telemetry_export: z.boolean().default(false),
  })
  .strict();

export type AutopilotConfigV2 = z.infer<typeof AutopilotConfigV2Schema>;

/** Every V2 key — one source for the "V2 key put in the main file" refusal (loader + doctor). */
export const AUTOPILOT_CONFIG_V2_KEYS = Object.keys(AutopilotConfigV2Schema.shape) as Array<
  keyof AutopilotConfigV2
>;
